var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4482 23.9655V24.8362C26.4482 25.7599 26.0812 26.6457 25.4281 27.2988C24.7749 27.952 23.8891 28.3189 22.9654 28.3189H16.8706",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4482 16.1293H22.9655C22.5037 16.1293 22.0607 16.3128 21.7342 16.6393C21.4076 16.9659 21.2241 17.4088 21.2241 17.8707V22.2241C21.2241 22.686 21.4076 23.1289 21.7342 23.4554C22.0607 23.782 22.5037 23.9655 22.9655 23.9655H26.4482V16.1293ZM26.4482 16.1293C26.4482 14.7572 26.178 13.3986 25.6529 12.1309C25.1278 10.8633 24.3582 9.71149 23.388 8.74128C22.4178 7.77107 21.266 7.00146 19.9984 6.47639C18.7307 5.95131 17.3721 5.68106 16 5.68106C14.6279 5.68106 13.2693 5.95131 12.0016 6.47639C10.734 7.00146 9.58219 7.77107 8.61198 8.74128C7.64177 9.71149 6.87216 10.8633 6.34708 12.1309C5.82201 13.3986 5.55176 14.7572 5.55176 16.1293M5.55176 16.1293V22.2241C5.55176 22.686 5.73522 23.1289 6.06179 23.4554C6.38837 23.782 6.83129 23.9655 7.29313 23.9655H9.03451C9.49635 23.9655 9.93927 23.782 10.2658 23.4554C10.5924 23.1289 10.7759 22.686 10.7759 22.2241V17.8707C10.7759 17.4088 10.5924 16.9659 10.2658 16.6393C9.93927 16.3128 9.49635 16.1293 9.03451 16.1293H5.55176Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersupport);
export default __webpack_public_path__ + "static/media/customersupport.2fb6d7ca5c6598511de86cc0a811835b.svg";
export { ForwardRef as ReactComponent };